var global = require('../internals/global');

var setToStringTag = require('../internals/set-to-string-tag'); // JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag


setToStringTag(global.JSON, 'JSON', true);